import { createRouter, createWebHistory } from 'vue-router'
import Tema from '../views/TemaView.vue'
import Home from '../views/home.vue'
import GR from '../views/GrHome.vue'
import GRView from '../views/GrView.vue'
import IAC from '../views/IacHome.vue'
import IACView from '../views/IacView.vue'
import PUIL from '../views/PuilHome.vue'
import PUILView from '../views/PuilView.vue'
import ENUNCIADO from '../views/EnunciadoHome.vue'
import EnunciadoView from '../views/EnunciadoView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      title: 'Incidente de Resolução de Demandas Repetitivas (IRDR)',
    },
    component: Home
  },
  {
    path: '/tema/:id?',
    name: 'Tema',
    meta: {
      title: 'Incidente de Resolução de Demandas Repetitivas (IRDR)',
    },
    component: Tema
  },
  {
    path: '/iachome',
    name: 'IAC',
    meta: {
      title: 'Incidente de Assunção de Competência (IAC)',
    },
    component: IAC
  },
  {
    path: '/iac/:id?',
    name: 'CIAC',
    meta: {
      title: 'Incidente de Assunção de Competência (IAC)',
    },
    component: IACView
  },
  {
    path: '/grhome',
    name: 'GR',
    meta: {
      title: 'Grupo de Representativos (GR)',
    },
    component: GR
  },
  {
    path: '/gr/:id?',
    name: 'CGR',
    meta: {
      title: 'Grupo de Representativos (GR)',
    },
    component: GRView
  },
  {
    path: '/puilhome',
    name: 'PUIL',
    meta: {
      title: 'Pedido de Uniformização de Interpretação de Lei (PUIL)',
    },
    component: PUIL
  },
  {
    path: '/puil/:id?',
    name: 'CPUIL',
    meta: {
      title: 'Pedido de Uniformização de Interpretação de Lei (PUIL)',
    },
    component: PUILView
  },
  {
    path: '/sumulahome',
    name: 'ENUNCIADO',
    meta: {
      title: 'Enunciados de Súmula',
    },
    component: ENUNCIADO
  },
  {
    path: '/sumula/:id?',
    name: 'CENUNCIADO',
    meta: {
      title: 'Enunciados de Súmula',
    },
    component: EnunciadoView
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


export const axios = require('axios').default;

export default router
